export const AVATAR_SM_WIDTH = 72
export const AVATAR_HEADING_WIDTH = 256
export const AVATAR_GRAPH_WIDTH = 128

// Add width param to image url
// Warning: It works only with images from Nhost storage
export function getResizedImageUrl<
  Url extends string | null | undefined,
  Return = Url extends null ? Exclude<Url, null> | undefined : Url,
>(url: Url, width: number): Return {
  // La chaîne vide n'est pas une URL : la traiter comme une absence. Sans ça
  // elle ressortait en '?w=72', valeur non vide qui traversait tous les gardes
  // `if (!avatar)` et faisait lever « Invalid avatar » à Crisp — page blanche
  // au login, incident du 18/06/2026 sur CartoGroov.
  if (url === undefined || url === null || url === '') {
    return undefined as Return
  }
  return `${url}${url.indexOf('?') === -1 ? '?' : '&'}w=${width}` as Return
}
